import React, { FC } from 'react';
import { TableToolBarProps } from './TableToolBarProps';
import { Stack } from '@mui/material';
import IngkaDropdownMenu from '../IngkaDropdownMenu';
import ColumnsButton from '../ColumnsButton';
import FiltersButton from '../FiltersButton';
import TableSettingsButtons from '../TableSettingsButtons';
import ExportTableButton from '../ExportTableButton';
import { QuickSearchInput } from '../ProjectListTable/toolbar/QuickSearchInput';

const TableToolBar: FC<TableToolBarProps> = ({
  filters,
  saveSettings,
  resetSettings,
  children,
  setFilterAnchorEl,
}) => {
  return (
    <Stack spacing={2}>
      <Stack
        direction="row"
        spacing={1}
        justifyContent={'space-between'}
        flexWrap={'wrap'}
        gap={2}
      >
        <Stack direction={'row'} spacing={1} flexWrap={'wrap'} gap={'6px'}>
          {filters.map((filter) => {
            if (filter.component) return filter.component;
            return <IngkaDropdownMenu {...filter} key={filter.id} />;
          })}
          <ColumnsButton />
          <FiltersButton setFilterAnchorEl={setFilterAnchorEl} />
          <TableSettingsButtons
            resetSettings={resetSettings}
            saveSettings={saveSettings}
          />
        </Stack>
        <Stack direction={'row'} spacing={1} ml={'auto !important'}>
          <QuickSearchInput size={'small'} />
          <ExportTableButton />
        </Stack>
      </Stack>
      {children && (
        <Stack spacing={2} direction={'row'}>
          {children}
        </Stack>
      )}
    </Stack>
  );
};

export default TableToolBar;
